<div provide-parent-form *ngIf="lineup">
	<bb-message
		*ngIf="lineupService?.numUniqueLive && lineupService.numUniqueLive >= lineupService.liveInfoThreshold"
		[type]="lineupService.numUniqueLive > lineupService.maxLiveCount ? 'error' : (lineupService.numUniqueLive < lineupService.maxLiveCount ? 'info' : 'warning')">
		You are using {{ lineupService.numUniqueLive }} out of a maximum of {{ lineupService.maxLiveCount }} unique live items in this lineup.
	</bb-message>

	<bb-week-time-grid
		[(ngModel)]="lineup.schedule" type="text" name="lineup"
		(ngModelChange)="onLineupUpdate(lineup)"
	></bb-week-time-grid>
</div>
